import { useMemo } from 'react';
import useFormatTournamentCurrency from './use-format-tournament-currency';
import insertPrizePoolValue from './insert-prize-pool-value';

const useConditionalPrizePool = (
	prizePoolText: string | null | undefined,
	prizePool: number | null | undefined,
	currencyCode: string | null | undefined
) => {
	const formatTournamentCurrency = useFormatTournamentCurrency(currencyCode);

	const conditionalPrizePool = useMemo(() => {
		const formattedPrizePool = formatTournamentCurrency(prizePool);

		if (prizePoolText) {
			return insertPrizePoolValue(prizePoolText, formattedPrizePool);
		}

		return formattedPrizePool;
	}, [prizePoolText, prizePool, formatTournamentCurrency]);

	return conditionalPrizePool;
};

export default useConditionalPrizePool;
